import rtDialog from '../dialog/rtDialog.vue';
import rtLookupView from './rtLookupView.vue';
const alias = {
  id: 'id',
  name: 'name'
};
export default {
  components: {
    rtDialog,
    rtLookupView
  },
  props: {
    value: {
      type: [Object, Array],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default() {
        return this.$tx('请选择', 'xpc.lookup.placeholder');
      }
    },
    displayFields: {
      type: Array,
      required: true
    },
    alias: {
      type: Object,
      default() {
        return alias;
      }
    },
    title: String
  },
  data() {
    return {
      inputHovering: false,
      visible: false,
      inputText: this.value ? this.value[this.alias.name] : '',
      total: 0,
      list: [],
      contentPopover: ''
    };
  },
  computed: {
    showClose() {
      if (!!this.inputText) {
        return !!this.inputHovering && !!this.inputText && !this.disabled;
      } else {
        return !!this.inputHovering && !!this.list && !this.disabled;
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal instanceof Array) {
        this.list = newVal;
      } else {
        this.inputText = newVal[this.alias.name] || '';
      }
    }
  },
  methods: {
    mouseenter() {
      setTimeout(() => {
        this.inputHovering = true;
      });
    },
    mouseleave() {
      setTimeout(() => {
        this.inputHovering = false;
      });
    },
    show() {
      if (this.disabled) {
        return;
      }
      this.visible = true;
      if (this.$refs && this.$refs.lookupView) {
        this.$refs.lookupView.$refs.table.handleIndexChange(1);
      }
    },
    change({ data }) {
      this.selected = data;
    },
    cancel() {
      this.$emit('cancel');
    },
    clear() {
      let obj = {};
      const { alias } = this;
      obj[alias.id] = '';
      obj[alias.name] = '';
      this.$emit('input', obj);
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/lookup/mixin.js